<template>
  <div class="relative inline-block text-left">
    <button
      @click.stop="toggleSelect"
      type="button"
      :disabled="disabled"
      class="optionButton justify-between"
      :class="[bg, optionCard ? 'px-1' : 'px-3']"
    >
      <ontick-text v-if="hideText" class="hidden md:flex">
        <template v-if="optionInitialCustomize.label ? optionInitialCustomize.label : optionInitialCustomize">
          <span
            v-show="!optionCard"
            class="text-ontick-carbon-900 pr-3 dark:text-gray-300"
            v-html="optionInitialCustomize.label ? optionInitialCustomize.label : optionInitialCustomize"
          ></span>
        </template>
      </ontick-text>
      <ontick-text v-else class="flex">
        <template v-if="optionInitialCustomize.label ? optionInitialCustomize.label : optionInitialCustomize">
          <span
            v-if="!optionCard"
            class="text-ontick-carbon-900 pr-3 dark:text-gray-300"
            v-html="optionInitialCustomize.label ? optionInitialCustomize.label : optionInitialCustomize"
          ></span>
        </template>
      </ontick-text>
      <span
        class="text-ontick-steel-400 transform transition-all duration-200 dark:text-gray-300"
        :class="rotate && showOptionsSelect ? 'rotate-180' : 'rotate-0'"
        v-html="optionInitialCustomize.icon ? optionInitialCustomize.icon : icon_arrow"
        v-show="optionInitialCustomize.icon || icon_arrow"
      ></span>
    </button>
    <portal to="modal">
      <transition
        enter-active-class="transform transition duration-300 ease-custom"
        enter-class="-translate-y-1/2 scale-y-0 opacity-0"
        enter-to-class="translate-y-0 scale-y-100 opacity-100"
        leave-active-class="transform transition duration-300 ease-custom"
        leave-class="translate-y-0 scale-y-100 opacity-100"
        leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
      >
        <div
          ref="box"
          v-click-outside="hide"
          :class="positionCustomize"
          :style="positionValues"
          v-if="showOptionsSelect"
          class="border-ontick-steel-300 bg-ontick-steel-100 dark:border-ontick-steel-500 dark:bg-ontick-steel-500 fixed z-50 mt-2 w-56 origin-top-right overflow-hidden rounded-md border shadow"
        >
          <button
            v-for="(item, key) in options"
            @click.stop="optionSelected(item)"
            :key="key"
            class="option_button group w-full"
          >
            <div class="flex items-center w-full">
              <span class="text-ontick-blue-500" v-html="item.icon" v-show="item.icon"></span>
              <p size="sm" class="ml-3">
                {{ item.label ? item.label : item == 0 ? "-" : item }}
              </p>
            </div>
            <span
              v-if="item.isNew"
              class="rounded leading-3 px-1.5 py-1 text-[10px] font-bold text-gray-50 bg-ontick-blue-600"
              >NOVO</span
            >
          </button>
          <dt
            v-show="footer != null"
            class="bg-ontick-steel-200 text-ontick-steel-400 dark:bg-ontick-steel-500 flex w-full items-center rounded-b-md px-5 py-2 text-left text-xs dark:text-gray-400"
          >
            Código:

            <span class="text-ontick-blue-500 ml-1 font-semibold">
              {{ footer }}
            </span>
          </dt>
        </div>
      </transition>
    </portal>
  </div>
</template>

<script>
import EventBus from "@/app/shared/utils/event_bus";
import ClickOutside from "vue-click-outside";

const icon_arrow = `<svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87" /> <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/> </svg>`;

export default {
  name: "ontick-form-dropdown",

  directives: {
    ClickOutside,
  },

  props: {
    optionInitial: {
      required: true,
      default: {},
    },
    optionCard: {
      type: Boolean,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    disabledOptionDefault: {
      type: Boolean,
      default: false,
    },
    footer: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rotate: { type: Boolean, default: true },

    position: {
      type: String,
      default: "right",
      validator: function (value) {
        return ["left", "right", "fixed"].indexOf(value) !== -1;
      },
    },

    bg: { type: String, default: "dark:bg-ontick-graphite-500 bg-gray-50" },
    hideText: {
      type: Boolean,
    },
  },

  data() {
    return {
      showOptionsSelect: false,
      optionDefault: null,
      ehThisSelect: false,
      thisSelect: false,
      icon_arrow: icon_arrow,
      dropdownPosition: {
        x: {
          referencePoint: "left",
          value: null,
        },
        y: {
          referencePoint: "top",
          value: null,
        },
      },
    };
  },

  computed: {
    positionValues() {
      if (this.position === "fixed") {
        return "top: 64px; right: 0;";
      } else {
        return `${this.dropdownPosition.y.referencePoint}: ${this.dropdownPosition.y.value}px; ${this.dropdownPosition.x.referencePoint}: ${this.dropdownPosition.x.value}px;`;
      }
    },
    positionCustomize() {
      return {
        "left-0": this.position == "left",
        "right-0": this.position == "right",
      };
    },
    optionInitialCustomize() {
      if (!this.optionDefault) {
        this.optionDefault = this.optionInitial;
      }
      return this.optionDefault;
    },
  },

  methods: {
    toggleSelect(e) {
      this.thisSelect = !this.thisSelect;
      this.showOptionsSelect = !this.showOptionsSelect;
      this.ehThisSelect = true;

      EventBus.$emit("CLOSE_SELECT", true);
      EventBus.$emit("CLOSE_DROPDOWN", true); //para menu da navbar

      const view = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      const position = {
        x: {
          referencePoint: null,
          value: null,
        },
        y: {
          referencePoint: null,
          value: null,
        },
      };

      //  ====================================
      //  Mantém a caixa sempre dentro da view
      //  ====================================
      //
      //  Dimensões da caixa
      //  ->  Largura: 224px
      //  ->  Altura: 154px
      //

      if (224 > view.width - e.x) {
        position.x = {
          referencePoint: "right",
          value: view.width - e.x,
        };
      } else {
        position.x = {
          referencePoint: "left",
          value: e.x,
        };
      }
      if (154 > view.height - e.y) {
        position.y = {
          referencePoint: "bottom",
          value: view.height - e.y,
        };
      } else {
        position.y = {
          referencePoint: "top",
          value: e.y,
        };
      }
      this.dropdownPosition = position;
    },
    optionSelected(item) {
      if (item?.action) {
        item.action();
      } else if (!this.disabledOptionDefault) {
        if (!item.label) {
          this.optionDefault = item;
        } else {
          this.optionDefault = {
            icon: item.icon,
            label: item.label,
          };
        }
      }
      this.showOptionsSelect = false;
      this.$emit("optionSelected", item);
    },
    hide() {
      this.showOptionsSelect = false;
    },
  },

  mounted() {
    // prevent click outside event with popupItem.
    this.popupItem = this.$el;
    EventBus.$on("CLOSE_SELECT", (payload) => {
      if (!this.ehThisSelect) {
        this.showOptionsSelect = false;
        this.thisSelect = false;
      } else {
        this.ehThisSelect = false;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.option_button {
  @apply text-ontick-carbon-900 hover:bg-ontick-steel-200 dark:hover:bg-ontick-steel-800 flex items-center px-4 py-2  text-xs dark:text-gray-300;
}
.optionButton {
  @apply flex min-w-full items-center rounded-lg py-1 text-sm  font-medium focus:outline-none;
}
.optionButtonCard {
  @apply hover:bg-ontick-steel-600 dark:bg-ontick-steel-700 -mr-8 inline-flex w-full items-center justify-center rounded-lg bg-gray-50 px-3 py-2 text-sm font-medium focus:outline-none dark:text-gray-300;
}
</style>
